var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "help-drawer-box" },
    [
      _c(
        "el-drawer",
        {
          staticClass: "news",
          attrs: {
            visible: _vm.dialogVisible,
            direction: "rtl",
            id: "help-cont",
            "modal-append-to-body": false,
            "custom-class": "help-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "container", class: _vm.isShow ? "show" : "hide" },
            [
              _c("div", { staticClass: "index_module_head" }, [
                _c("span", { staticClass: "head_span heaper-world" }, [
                  _vm._v(_vm._s(_vm.$i18.language("帮助中心"))),
                ]),
                _c(
                  "span",
                  { staticClass: "close", on: { click: _vm.goClose } },
                  [_c("i", { staticClass: "el-icon-close" })]
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { "min-height": "450px" },
                },
                [
                  _c("div", { staticClass: "heaper-top-box" }, [
                    _c("div", { staticClass: "all-documents-text" }, [
                      _vm._v(_vm._s(_vm.$i18.language("全部文档"))),
                    ]),
                    _c("div", { staticClass: "heaper-card-box" }, [
                      _c(
                        "div",
                        { staticClass: "left-box" },
                        [
                          _c("p", { staticClass: "desc1" }, [
                            _vm._v(
                              _vm._s(_vm.$i18.language("使用时常见的问题"))
                            ),
                          ]),
                          _c("p", { staticClass: "desc2" }, [
                            _vm._v(_vm._s(_vm.$i18.language("在文档中找答案"))),
                          ]),
                          _c(
                            "el-button",
                            {
                              class: [
                                "show-button-style btn-height-28 readMe-btn",
                                _vm.lang == "en"
                                  ? "en-readMe-btn"
                                  : "zh-readMe-btn",
                              ],
                              attrs: { size: "mini" },
                              on: { click: _vm.readMe },
                            },
                            [_vm._v(_vm._s(_vm.$i18.language("查看")))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm.detailList && _vm.detailList.length > 0 && !_vm.loading
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "container-body",
                            style: { height: `${_vm.screenHeight}` },
                          },
                          [
                            _vm.videoList && _vm.videoList.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "style_module_list" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "heaper-world heaper-world-c",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$i18.language("帮助视频"))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "video-style" },
                                      [
                                        _c(
                                          "el-carousel",
                                          {
                                            attrs: {
                                              trigger: "click",
                                              height: "200px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.videoList,
                                            function (item, index) {
                                              return _c(
                                                "el-carousel-item",
                                                { key: index },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "title-show",
                                                    },
                                                    [_vm._v(_vm._s(item.title))]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "videoIcon",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clickVideo(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("svg-icon", {
                                                        attrs: {
                                                          name: "videoL",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("img", {
                                                    staticStyle: {
                                                      width: "304px",
                                                    },
                                                    attrs: {
                                                      src: item.thumb,
                                                      alt: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clickVideo(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.helpList && _vm.helpList.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "style_module_list" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "heaper-world heaper-world-c",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$i18.language("帮助文档"))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "ul",
                                      { staticClass: "style_module_group" },
                                      _vm._l(
                                        _vm.helpList,
                                        function (item, idx) {
                                          return _c(
                                            "li",
                                            {
                                              key: idx,
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goDetailsCont(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "style_module_item_text",
                                                },
                                                [_vm._v(_vm._s(item))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
          !_vm.isShow
            ? _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "index_module_head" }, [
                  _c(
                    "span",
                    { staticClass: "go-back", on: { click: _vm.goBack } },
                    [
                      _c("i", { staticClass: "el-icon-arrow-left" }),
                      _c("span", { staticClass: "head_span" }, [
                        _vm._v(_vm._s(_vm.$i18.language("返回"))),
                      ]),
                    ]
                  ),
                  _c(
                    "span",
                    { staticClass: "close", on: { click: _vm.goClose } },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                ]),
                _c("div", { staticClass: "style_modul_detail" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.detailCurrent.title)),
                  ]),
                  _c("div", { staticClass: "h-style markdown-body" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.detailCurrent.mdDesc
                            ? _vm.detailCurrent.mdDesc
                            : _vm.detailCurrent.htmlDesc
                        ),
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "maskLayer", on: { click: _vm.goClose } }),
        ]
      ),
      _c("help-video", {
        ref: "helpVideo",
        attrs: { currentVideo: _vm.currentVideo },
        on: { clearVideo: _vm.clearVideo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }